import React from 'react';

// Letzte Auffanglinie: statt weißem Bildschirm eine sichtbare Meldung mit Neu-laden-Option.
export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    try { console.error('[AppErrorBoundary]', error, info?.componentStack); } catch { /* noop */ }
  }

  render() {
    if (!this.state.error) return this.props.children;
    const storageBlocked = typeof window !== 'undefined' && !!window.__gle_storage_fallback;
    const msg = String(this.state.error?.message || this.state.error || 'Unbekannter Fehler');
    return (
      <div data-testid="app-error-fallback" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, background: '#f8fafc', color: '#0f172a', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
        <div style={{ maxWidth: 480, width: '100%', background: '#fff', border: '1px solid #e2e8f0', borderRadius: 16, padding: 24, boxShadow: '0 10px 30px rgba(15,23,42,0.08)' }}>
          <h1 style={{ fontSize: 20, fontWeight: 700, margin: '0 0 8px' }}>Die Seite konnte nicht geladen werden</h1>
          <p style={{ fontSize: 14, lineHeight: 1.5, margin: '0 0 12px', color: '#475569' }}>
            Beim Anzeigen ist ein Fehler aufgetreten. Bitte laden Sie die Seite neu. Falls das Problem bestehen bleibt,
            prüfen Sie in Safari unter „Einstellungen → Safari“, ob „Alle Cookies blockieren“ aktiv ist, und schalten Sie es aus.
          </p>
          {storageBlocked && (
            <p data-testid="app-error-storage-hint" style={{ fontSize: 13, margin: '0 0 12px', color: '#b45309' }}>
              Hinweis: Der Website-Speicher ist in diesem Browser blockiert.
            </p>
          )}
          <p data-testid="app-error-message" style={{ fontSize: 12, margin: '0 0 16px', color: '#64748b', wordBreak: 'break-word' }}>{msg}</p>
          <button
            type="button"
            data-testid="app-error-reload-btn"
            onClick={() => window.location.reload()}
            style={{ background: '#059669', color: '#fff', border: 0, borderRadius: 999, padding: '10px 18px', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}
          >
            Seite neu laden
          </button>
        </div>
      </div>
    );
  }
}
